import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSubmissions(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('sales/sales-submission', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchSubmission(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`sales/sales-submission/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    registerPayment(ctx, { id, formData }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`sales/sales-submission/${id}/register-payment`, formData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateItemRequiredInformation(ctx, { submissionId, itemId, formData }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`sales/sales-submission/${submissionId}/item/${itemId}/required-information`, formData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateServiceAgent(ctx, { id, agentId }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`sales/sales-submission/${id}/service-agent`, { agentId })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateSalesAgent(ctx, { id, agentId }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`sales/sales-submission/${id}/sales-agent`, { agentId })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updatePurchaserDetails(ctx, { id, formData }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`sales/sales-submission/${id}/purchaser-details`, formData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateItemIntendedUser(ctx, {
      submissionId, itemId, userId, formData,
    }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`sales/sales-submission/${submissionId}/item/${itemId}/intended-user/${userId}`, formData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateItemAuthorizedPerson(ctx, {
      submissionId, itemId, userId, formData,
    }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`sales/sales-submission/${submissionId}/item/${itemId}/authorized-person/${userId}`, formData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateItemInstallment(ctx, { submissionId, itemId, formData }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`sales/sales-submission/${submissionId}/item/${itemId}/installment`, formData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateItemPromotions(ctx, { submissionId, itemId, formData }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`sales/sales-submission/${submissionId}/item/${itemId}/promotions`, formData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
